<template>
  <v-container fluid pa-0>
    <v-row>
      <v-col cols="12" class="py-0">
        <v-container fluid py-0>
          <v-row align="center">
            <h1 class="headline">Routes</h1>
            <v-spacer></v-spacer>
            <v-text-field
              label="Filter"
              v-model="search"
              :outlined="outlinedInputs"
              dense
              class="ma-0"
              append-icon="mdi-magnify"
              single-line
              hide-details
            ></v-text-field>

            <v-btn
              :loading="uploading"
              :disabled="uploading"
              color="blue-grey"
              class="ma-2 white--text"
              @click="onUpload"
            >
              Import *.kml File
              <v-icon right dark>mdi-cloud-upload</v-icon>
            </v-btn>
            <input
              ref="fileChooser"
              accept=".csv,.kml"
              type="file"
              style="display: none"
              @change="onFileChange"
            />
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn
                  small
                  v-on="on"
                  class="ml-2"
                  fab
                  @click="onCreateRoute"
                  color="primary"
                >
                  <v-icon small>mdi-file-plus-outline</v-icon>
                </v-btn>
              </template>
              Create New Route
            </v-tooltip>
          </v-row>
          <v-row>
            <v-col class="px-0">
              <v-card outlined>
                <v-data-table
                  :items="routes"
                  :headers="headers"
                  :search="search"
                  :loading="loading"
                >
                  <template v-slot:item.status="{ item }">
                    <v-progress-circular
                      v-if="item.status == 'error'"
                      indeterminate
                      color="purple"
                    ></v-progress-circular>
                    <v-icon v-else color="success">mdi-check</v-icon>
                  </template>
                  <template v-slot:item.actions="{ item }">
                    <default-list-actions
                      :item="item"
                      @deleteItem="deleteItem"
                      @editItem="editItem"
                      hide-view
                      ><template v-slot:extraButton>
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on }">
                            <v-btn
                              v-on="on"
                              icon
                              small
                              class="mx-0"
                              @click="editItemContents(item)"
                            >
                              <v-icon color="blue" small>mdi-camera</v-icon>
                            </v-btn>
                          </template>
                          <span>Route Contents</span>
                        </v-tooltip>
                      </template>
                    </default-list-actions>
                  </template>
                </v-data-table>
              </v-card>
              <route-details-dialog
                :show="showRouteDetailsDialog"
                @close="showRouteDetailsDialog = false"
                v-model="selectedRoute"
                @save="onRouteSave"
                @save-poi="onSavePOI"
                @delete-poi="onDeletePOI"
                isSource
                :source-pois="selectedRoutePOIs"
                hide-description
                show-tags
                show-color-picker
              ></route-details-dialog>
              <div v-if="debug">{{ selectedRoutePOIs }}</div>
            </v-col>
          </v-row>
        </v-container>
      </v-col>
    </v-row>
    <basic-dialog
      title="Route Contents"
      @close="showRouteContentsDialog = false"
      :show="showRouteContentsDialog"
    >
      <template v-slot:title>
        Contents for {{ selectedRoute ? selectedRoute.name : "Contents" }}
      </template>
      <contents
        v-if="selectedRoute.id != null"
        :owner-id="selectedRoute.id"
        owner-name="ROUTE"
      ></contents>
    </basic-dialog>
  </v-container>
</template>

<script>
import * as fb from "../../../../constants/gt-routes-firebase";
import { GET_FB_TOKEN_QUERY } from "../../../../constants/graphql";
import DefaultListActions from "../../shared/DefaultListActions";
import RouteDetailsDialog from "../../itineraries/routes/RouteDetailsDialog";
import BasicDialog from "../../shared/BasicDialog.vue";
import Contents from "../../shared/contents/Contents.vue";
import gql from "graphql-tag";
import EventBus from "../../../../store/event-bus";
const UPDATE_TAGS_MUTATION = gql`
  mutation updateRouteTags($input: UpdateAvailableTagsInput!) {
    updateAvailableTags(input: $input) {
      success
      error
      message
    }
  }
`;
export default {
  name: "routes-list",

  components: { DefaultListActions, RouteDetailsDialog, BasicDialog, Contents },

  data() {
    return {
      debug: false,
      routes: [],
      search: "",
      loading: false,
      uploading: false,
      showRouteDetailsDialog: false,
      selectedRoute: { name: "New Route" },
      selectedRoutePOIs: [],
      headers: [
        {
          text: "Name",
          sortable: false,
          value: "name",
          name: "name",
        },
        {
          text: "Status",
          sortable: false,
          value: "status",
          name: "status",
        },
        {
          text: "Tags",
          sortable: false,
          value: "tags",
          name: "tags",
        },
        {
          text: "Actions",
          value: "actions",
          sortable: false,
          name: "actions",
          align: "center",
        },
      ],
      showRouteContentsDialog: false,
    };
  },

  computed: {
    fbToken() {
      return this.gtRoutesFbToken ? this.gtRoutesFbToken : "notoken";
    },
    outlinedInputs() {
      return this.$store.getters.localSettings("outlinedInputs");
    },
  },
  methods: {
    editItemContents(item) {
      this.selectedRoute = { ...item };
      this.showRouteContentsDialog = true;
    },
    getRoutes() {
      this.loading = true;
      fb.routesCollection
        .where("uid", "==", fb.auth.currentUser.uid)
        .orderBy("created", "desc")
        //.limitToLast(10)
        .onSnapshot((snapshot) => {
          let routes = [];

          snapshot.forEach((doc) => {
            let route = doc.data();
            route.id = doc.id;
            route.code = doc.id;
            routes.push(route);
            //console.log(doc.data());
          });

          this.routes = [...routes];
          this.loading = false;
        });
    },
    getPois() {
      fb.routesCollection
        .doc(this.selectedRoute.id)
        .collection("pois")
        .onSnapshot((snapshot) => {
          let pois = [];
          snapshot.forEach((doc) => {
            let poi = doc.data();
            poi.id = doc.id;
            pois.push(poi);
          });
          this.selectedRoutePOIs = [...pois];
        });
    },
    onUpload() {
      this.$refs.fileChooser.click();
    },
    onFileChange(event) {
      //console.log(event, );
      if (this.$refs.fileChooser.files.length > 0) {
        this.uploading = true;
        const file = this.$refs.fileChooser.files[0];
        const filename = file.name;

        const fileRef = fb.routesStorage.child(
          `${fb.auth.currentUser.uid}_${filename}`
        );
        // //console.log($user);
        fileRef
          .put(file)
          .then((snapshot) => {
            this.uploading = false;
            this.$store.dispatch("showAppSnackbar", {
              msg: "Your file import was started.",
              color: "success",
            });
          })
          .catch((error) => console.log(error));
      }
    },
    editItem(item) {
      this.selectedRoute = { ...item };
      this.getPois();
      this.showRouteDetailsDialog = true;
    },
    async deleteItem(item) {
      const res = await fb.routesCollection.doc(item.id).delete();
    },
    async onRouteSave(payload) {
      if (this.selectedRoute.id) {
        const routeRef = await fb.routesCollection
          .doc(this.selectedRoute.id)
          .update({
            name: payload.name,
            description: payload.description,
            coordinates: payload.coordinates,
            tags: payload.tags,
            color: payload.color,
          });
        this.updateTags(this.selectedRoute.id, payload.tags);
      } else {
        const newRouteRef = await fb.routesCollection.add({
          name: payload.name,
          description: payload.description ? payload.description : "",
          coordinates: payload.coordinates,
          created: new Date(),
          status: "processing",
          statusDescription: "Creating tiles...",
          packageURL: "",
          filename: "",
          uid: fb.auth.currentUser.uid,
          color: payload.color,
        });
        this.updateTags(newRouteRef.id, payload.tags); ///console.log("saving new route", payload);
      }

      this.showRouteDetailsDialog = false;
    },
    async onDeletePOI(payload) {
      await fb.routesCollection
        .doc(this.selectedRoute.id)
        .collection("pois")
        .doc(payload.id)
        .delete();
    },
    async onSavePOI(payload) {
      //console.log("poi payload", payload);
      const poi = {
        name: payload.name,
        description: payload.description,
        lat: payload.lat,
        lng: payload.lng,
        radius: payload.radius,
        type: { ...payload.type },
        audio: payload.audio,
      };
      if (payload.id) {
        const poiRef = fb.routesCollection
          .doc(this.selectedRoute.id)
          .collection("pois")
          .doc(payload.id)
          .update(poi);
      } else {
        const poisRef = fb.routesCollection
          .doc(this.selectedRoute.id)
          .collection("pois");
        const res = await poisRef.add(poi);
      }
    },
    onCreateRoute() {
      console.log("add new");
      this.selectedRoute = { name: "New Route", coordinates: "" };
      this.showRouteDetailsDialog = true;
    },
    updateTags(routeId, tags) {
      this.$apollo
        .mutate({
          mutation: UPDATE_TAGS_MUTATION,
          variables: {
            input: { owner: "ROUTE_ADMIN", ownerId: routeId, tags: tags },
          },
        })
        .then((res) => {
          EventBus.$emit("update-tags");
        })
        .catch((err) => {
          console.error("update tags error", err);
        });
    },
  },

  apollo: {
    gtRoutesFbToken: {
      query: GET_FB_TOKEN_QUERY,

      result({ data }) {
        //authorize and get routes list

        if (!fb.auth.currentUser) {
          const token = data.gtRoutesFbToken;
          console.log("signin with token");
          fb.auth
            .signInWithCustomToken(token)
            .then((res) => {
              this.getRoutes();
            })
            .catch((err) => console.log("Sign in error:", err));
        } else {
          this.getRoutes();
        }
      },
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/gt/admin/destinations/RoutesList.vue